module.exports = __webpack_public_path__ + "static/media/LGSmartRegular__W.f202f18f.woff";